import * as Types from '../../../../__generated__/graphql-base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AutoApplyFreeTextPreferencesQueryVariables = Types.Exact<{ [key: string]: never }>;

export type AutoApplyFreeTextPreferencesQuery = {
    __typename?: 'Query';
    autoApplyInfo?:
        | {
              __typename?: 'AutoApplyInfoPayload';
              freeTextPreference?:
                  | {
                        __typename?: 'FreeTextPreference';
                        text: string;
                        lastModifiedTimestamp?: number | null | undefined;
                        modifiedByJobSeeker: boolean;
                    }
                  | null
                  | undefined;
          }
        | null
        | undefined;
};

export const AutoApplyFreeTextPreferencesDocument = gql`
    query AutoApplyFreeTextPreferences {
        autoApplyInfo {
            freeTextPreference {
                text
                lastModifiedTimestamp
                modifiedByJobSeeker
            }
        }
    }
`;

/**
 * __useAutoApplyFreeTextPreferencesQuery__
 *
 * To run a query within a React component, call `useAutoApplyFreeTextPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAutoApplyFreeTextPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAutoApplyFreeTextPreferencesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAutoApplyFreeTextPreferencesQuery(
    baseOptions?: Apollo.QueryHookOptions<
        AutoApplyFreeTextPreferencesQuery,
        AutoApplyFreeTextPreferencesQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<
        AutoApplyFreeTextPreferencesQuery,
        AutoApplyFreeTextPreferencesQueryVariables
    >(AutoApplyFreeTextPreferencesDocument, options);
}
export function useAutoApplyFreeTextPreferencesLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        AutoApplyFreeTextPreferencesQuery,
        AutoApplyFreeTextPreferencesQueryVariables
    >,
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<
        AutoApplyFreeTextPreferencesQuery,
        AutoApplyFreeTextPreferencesQueryVariables
    >(AutoApplyFreeTextPreferencesDocument, options);
}
export function useAutoApplyFreeTextPreferencesSuspenseQuery(
    baseOptions?:
        | Apollo.SkipToken
        | Apollo.SuspenseQueryHookOptions<
              AutoApplyFreeTextPreferencesQuery,
              AutoApplyFreeTextPreferencesQueryVariables
          >,
) {
    const options =
        baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
    return Apollo.useSuspenseQuery<
        AutoApplyFreeTextPreferencesQuery,
        AutoApplyFreeTextPreferencesQueryVariables
    >(AutoApplyFreeTextPreferencesDocument, options);
}
export type AutoApplyFreeTextPreferencesQueryHookResult = ReturnType<
    typeof useAutoApplyFreeTextPreferencesQuery
>;
export type AutoApplyFreeTextPreferencesLazyQueryHookResult = ReturnType<
    typeof useAutoApplyFreeTextPreferencesLazyQuery
>;
export type AutoApplyFreeTextPreferencesSuspenseQueryHookResult = ReturnType<
    typeof useAutoApplyFreeTextPreferencesSuspenseQuery
>;
export type AutoApplyFreeTextPreferencesQueryResult = Apollo.QueryResult<
    AutoApplyFreeTextPreferencesQuery,
    AutoApplyFreeTextPreferencesQueryVariables
>;
